export default [
  {
    path:'/storeDetail',
    name:'storeDetail',
    meta: {
      index: 21
    },
    component: () => import('@/views/storeDetail/index.vue')
  }
]